import React from 'react';
import PropTypes from 'prop-types';
var DefaulTabInner = function DefaulTabInner(props) {
  return /*#__PURE__*/React.createElement("button", props.tabProps, props.children, Object.prototype.hasOwnProperty.call(props, 'iconProps') && /*#__PURE__*/React.createElement("span", props.iconProps));
};
export default DefaulTabInner;